function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33",
  transform: "translate(-415 -3939)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 32",
  cx: 37.5,
  cy: 37.5,
  r: 37.5,
  transform: "translate(415 3939)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon material-arrow-upward",
  d: "M474.926 3976.5l-3.953-3.879-15.67 15.351v-33.481h-5.607v33.481l-15.642-15.379-3.981 3.907 22.427 22.009z",
  fill: "#f9cec8"
}));
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75"
  }, props), _ref);
};
export default SvgArrowDown;